import { T } from "../../app/tokens.js";

/**
 * Measure displayed labels at the rendered pill typography. The caller owns
 * memoization and refreshes the supplied computed style after fonts are ready.
 * SSR, unavailable canvas and failed measurements return the supplied total
 * border-box fallback width (not a text-only width).
 */
export function pillMinWidth(labels, fallback = 100, typography) {
  try {
    if (typeof document === "undefined" || !labels.length) return fallback;
    const style = typography || (typeof getComputedStyle === "function" && document.body
      ? getComputedStyle(document.body) : null);
    if (!style?.fontFamily) return fallback;
    const context = document.createElement("canvas").getContext("2d");
    if (!context) return fallback;
    context.font = `${style.fontStyle || "normal"} ${style.fontWeight || T.fwSemibold} ${style.fontSize || `${T.fsXs}px`} ${style.fontFamily}`;
    // Canvas does not inherit CSS letter spacing. Include it explicitly.
    const spacing = parseFloat(style.letterSpacing) || 0;
    const widths = labels.map(label => context.measureText(label).width + [...label].length * spacing);
    if (widths.some(width => !Number.isFinite(width) || width < 0)) return fallback;
    const borders = (parseFloat(style.borderLeftWidth) || 0) + (parseFloat(style.borderRightWidth) || 0);
    return Math.ceil(Math.max(...widths)) + 20 + borders;
  } catch {
    return fallback;
  }
}
